/* eslint-disable */
import { ErrorHandler } from './errorHandler';
import axios, { AxiosInstance } from 'axios';
import { Service } from 'vue-di-container';
import { Toaster } from './toast';


@Service()
export default class AxiosService {
    public axiosInstance: AxiosInstance;

    constructor() {
        const config = {
            baseURL: process.env.BASE_URL,
            // timeout: 60 * 1000, // Timeout
            // withCredentials: true, // Check cross-site Access-Control
        };

        this.axiosInstance = axios.create(config);

        this.axiosInstance.interceptors.request.use(
            (axiosRequestConfig) => axiosRequestConfig,
            (error) => ErrorHandler.errorResponseHandler(error),
        );

        // Add a response interceptor
        this.axiosInstance.interceptors.response.use(
            (response: any) => {
                //debugger;
                //console.log("response-axiosInstance:", response);
                let result = response.data;
                if (typeof response.data === 'string') {
                    result =  JSON.parse(JSON.stringify(response.data));
                    response.data = result;
                }
                const statusCode = result.statusCode;
                if (statusCode == 200 && (result.errorMessage != null )) {
                    Toaster.error({ message: result.errorMessage });
                }     
                if (statusCode >= 400 && statusCode <= 599) {
                    Toaster.error({ message: result.errorMessage || 'حدث خطأ أثناء تنفيذ طلبك. يرجى المحاولة لاحقاً.' });
                    return Promise.reject(response);
                } else if (statusCode == 0) {
                    Toaster.error({ message: 'الخدمة لا تعمل. الرجاء المحاولة في وقت لاحق.' });
                }

                return Promise.resolve(response);
            },
            (error) => {
                // ErrorHandler.errorResponseHandler(error);
                window.HideLoader();
                error = JSON.parse(error);
                if (error.response.status === 500) {
                    if (error?.response?.data?.exception?.Message)
                        Toaster.error({ message: error?.response?.data?.exception?.Message });
                    else
                        Toaster.error({ message: 'حدث خطا ما في النظام' });

                }

                return Promise.reject(error);
            },
        );
    }
}
